<!-- Container-fluid starts-->
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    <h5>Add Product</h5>
                </div>
                <div class="card-body">


                    <div class="row product-adding">
                        <div class="col-xl-5">
                            <div class="add-product">
                                <div class="row">
                                    <div class="col-xl-9 xl-50 col-sm-6 col-9">
                                        <img [src]="url[0].img" alt="test" class="img-fluid image_zoom_1">
                                    </div>
                                    <div class="col-xl-3 xl-50 col-sm-6 col-3">
                                        <ul class="file-upload-product">
                                            <li *ngFor="let item of url; let i=index">
                                                <div class="box-input-file">
                                                    <input class="upload" type="file" (change)="readUrl($event,i)">
                                                    <img class="imgUpload" alt="" [src]="item.img">
                                                </div>
                                                <div>
                                                    <img class="imgUpload" [src]="item.del"
                                                        (click)="deletImg($event,i)">
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-7">
                            <form class="needs-validation" [formGroup]="productForm" novalidate>
                                <div class="add-product-form">
                                    <div class="form-group row">
                                        <label for="validationCustom01" class="col-xl-3 col-sm-4 mb-0">Product Code
                                            : <span
                                                *ngIf="productForm.controls.codeproduct.touched && productForm.controls.codeproduct.errors?.required"
                                                class="text text-danger">
                                                *
                                            </span></label>
                                        <input class="form-control col-xl-8 col-sm-7" id="validationCustom01"
                                            type="text" [formControl]="productForm.controls['codeproduct']" required>

                                    </div>
                                    <div class="form-group row">
                                        <label for="validationCustom01" class="col-xl-3 col-sm-4 mb-0">Title
                                            :   <span *ngIf="productForm.controls.title.touched && productForm.controls.title.errors?.required"
                                            class="text text-danger">
                                            *
                                        </span></label>
                                        <input class="form-control col-xl-8 col-sm-7" id="validationCustom01"
                                            type="text" [formControl]="productForm.controls['title']" required>
                                    </div>
                                    <div class="form-group row">
                                        <label for="validationCustom01" class="col-xl-3 col-sm-4 mb-0">Title fr
                                            :   <span *ngIf="productForm.controls.title_fr.touched && productForm.controls.title_fr.errors?.required"
                                            class="text text-danger">
                                            *
                                        </span></label>
                                        <input class="form-control col-xl-8 col-sm-7" id="validationCustom01"
                                            type="text" [formControl]="productForm.controls['title_fr']" required>
                                    </div>
                                    <div class="form-group row">
                                        <label for="validationCustom01" class="col-xl-3 col-sm-4 mb-0">Title es
                                            :   <span *ngIf="productForm.controls.title_es.touched && productForm.controls.title_es.errors?.required"
                                            class="text text-danger">
                                            *
                                        </span></label>
                                        <input class="form-control col-xl-8 col-sm-7" id="validationCustom01"
                                            type="text" [formControl]="productForm.controls['title_es']" required>
                                    </div>
                                    <div class="form-group row">
                                        <label for="exampleFormControlSelect1" class="col-xl-3 col-sm-4 mb-0">Select
                                            Category
                                            : <span *ngIf="productForm.get('category').errors?.testCategoryForbidden"
                                                class="text-danger">
                                                *
                                            </span></label>

                                        <select [formControl]="productForm.controls['category']"
                                            class="form-control digits col-xl-8 col-sm-7" (change)="getCategories()">
                                            <option *ngFor="let category of categoryList" [ngValue]="category">
                                                {{category.description}}
                                            </option>
                                        </select>
                                        <!-- Error Message -->
                                        <!-- Error message display -->

                                    </div>
                                    <div *ngIf="subcategoriesVisible" class="form-group row">
                                        <label for="exampleFormControlSelect1" class="col-xl-3 col-sm-4 mb-0">Select
                                            Subcategory
                                            : <span *ngIf="productForm.get('subcategory').errors?.subcategoryForbidden"
                                                class="text-danger">
                                                *
                                            </span></label>
                                        <select [formControl]="productForm.controls['subcategory']"
                                            class="form-control digits col-xl-8 col-sm-7"
                                            id="exampleFormControlSelect1">
                                            <option *ngFor="let subcategory of subcategoryList" [ngValue]="subcategory">
                                                {{subcategory.description}}
                                            </option>
                                        </select>

                                    </div>
                                    <div class="form-group row">
                                        <label for="exampleFormControlSelect1" class="col-xl-3 col-sm-4 mb-0">Select
                                            Brand
                                            : <span *ngIf="productForm.get('brand').errors?.brandForbidden"
                                                class="text-danger">
                                                *
                                            </span></label>
                                        <select [formControl]="productForm.controls['brand']"
                                            class="form-control digits col-xl-8 col-sm-7"
                                            id="exampleFormControlSelect1">
                                            <option *ngFor="let brand of brandList" [ngValue]="brand">
                                                {{brand.brand1}}</option>
                                        </select>



                                    </div>
                                    <div class="form-group row">
                                        <label for="exampleFormControlSelect1" class="col-xl-3 col-sm-4 mb-0">Select
                                            Tag
                                            :</label>
                                        <textarea [formControl]="productForm.controls['tag']">  </textarea>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-xl-3 col-md-4">Sale</label>
                                        <div class="checkbox checkbox-primary col-md-7">
                                            <input id="checkbox-primary-1" type="checkbox"
                                                [formControl]="productForm.controls['sale']" data-original-title=""
                                                title="">
                                            <label for="checkbox-primary-1">Include</label>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-xl-3 col-md-4">Has Color</label>
                                        <div class="checkbox checkbox-primary col-md-7">
                                            <input id="checkbox-primary-2" type="checkbox"
                                                [formControl]="productForm.controls['isproducthascolor']" data-original-title=""
                                                title="">
                                            <label for="checkbox-primary-2">Has color</label>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-xl-3 col-sm-4">Add Description : <span
                                                *ngIf="productForm.get('description')?.errors?.descriptionforbidden"
                                                class="text-danger">*</span> </label>
                                        <div class="col-xl-8 col-sm-7 pl-0 description-sm">
                                            <ck-editor [formControl]="productForm.controls['description']"
                                                name="editor1" [(ngModel)]="editorValue" skin="moono-lisa" language="en"
                                                [fullPage]="true"></ck-editor>
                                        </div>

                                    </div>

                                    <div class="form-group row">
                                        <label class="col-xl-3 col-sm-4">Add Description Es: <span
                                                *ngIf="productForm.get('description_es')?.errors?.descriptionforbidden"
                                                class="text-danger">*</span> </label>
                                        <div class="col-xl-8 col-sm-7 pl-0 description-sm">
                                            <ck-editor [formControl]="productForm.controls['description_es']"
                                                name="editor2" [(ngModel)]="editorValuees" skin="moono-lisa" language="en"
                                                [fullPage]="true"></ck-editor>
                                        </div>

                                    </div>

                                    <div class="form-group row">
                                        <label class="col-xl-3 col-sm-4">Add Description FR : <span
                                                *ngIf="productForm.get('description_fr')?.errors?.descriptionforbidden"
                                                class="text-danger">*</span> </label>
                                        <div class="col-xl-8 col-sm-7 pl-0 description-sm">
                                            <ck-editor [formControl]="productForm.controls['description_fr']"
                                                name="editor3" [(ngModel)]="editorValuefr" skin="moono-lisa" language="en"
                                                [fullPage]="true"></ck-editor>
                                        </div>

                                    </div>
                                </div>
                            </form>
                            <div class="form-group row mb-0">
                                <div class="product-buttons col-sm-8 offset-xl-3 offset-sm-4">
                                    <div class="modal-footer">

                                        <button type="button" class="btn btn-primary" data-toggle="modal"
                                            data-original-title="test" data-target="#exampleModal"
                                            (click)="open(content)">Add Variant</button>
                                        <div name="buttonSpace"></div>

                                        <button class="btn btn-secondary"
                                            (click)="saveProduct(productForm)">Save</button>
                                    </div>

                                    <ng-template #content let-modal>
                                        <div class="modal-header">
                                            <h5 class="modal-title f-w-600" id="exampleModalLabel">Add Brand</h5>
                                            <button type="button" class="close" aria-label="Close"
                                                (click)="modal.dismiss('Cross click')">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div class="modal-body">
                                            <form class="needs-validation">
                                                <div class="form">
                                                    <div class="form-group">


                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                        <div class="modal-footer">
                                            <button class="btn btn-primary">Save</button>
                                            <button class="btn btn-secondary" type="button" data-dismiss="modal"
                                                (click)="modal.dismiss('Cross click')">
                                                Close</button>
                                        </div>
                                    </ng-template>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="batchDelete" class="category-table custom-datatable">
                        <div class="table-responsive">
                            <ng2-smart-table [settings]="settings" [source]="Source"
                                (editConfirm)="updateRecord($event)" (deleteConfirm)="deleteRecord($event)">
                            </ng2-smart-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Container-fluid Ends-->